// ButtonComponent.tsx
import React from "react";
import { Button, ButtonProps } from "@material-ui/core";

interface ButtonComponentProps extends ButtonProps {
  width?: number;
  height?: number;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({
  width,
  height,
  ...rest
}) => {
  const style: React.CSSProperties = {
    width: width ?? "auto",
    height: height ?? "auto",
  };

  return <Button style={style} {...rest} />;
};

export default ButtonComponent;
